export default __webpack_public_path__ + "static/media/logo.a60778ad.svg";